import { create } from 'zustand';
import type { UserResponse } from '@/lib/api/models';
import { type Permission, permissionsForRoles } from './permissions';

type AuthStatus = 'loading' | 'authenticated' | 'anonymous';

interface AuthState {
  status: AuthStatus;
  user: UserResponse | null;
  permissions: Set<Permission>;
  setUser: (user: UserResponse | null) => void;
  setLoading: () => void;
  reset: () => void;
  has: (permission: Permission) => boolean;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  status: 'loading',
  user: null,
  permissions: new Set(),
  setUser: (user) =>
    set({
      user,
      status: user ? 'authenticated' : 'anonymous',
      permissions: user ? permissionsForRoles(user.roles ?? []) : new Set(),
    }),
  setLoading: () => set({ status: 'loading' }),
  reset: () => set({ user: null, status: 'anonymous', permissions: new Set() }),
  has: (permission) => get().permissions.has(permission),
}));
